import type { CancelBookingFlowStep } from '@/scopes/account/booking-details/pages/components/CancelBookingAction/types'
import type { FullCancellationSheetVariant } from '@/scopes/account/booking-details/pages/selectors/fullCancellationSelectors'
import { FullCancellationErrorResult } from '@/scopes/account/booking-details/pages/components/CancelBookingAction/steps/FullCancellationErrorResult'
import { FullCancellationSubmitResult } from '@/scopes/account/booking-details/pages/components/CancelBookingAction/steps/FullCancellationSubmitResult'
import { PartialCancellationSubmitResult } from '@/scopes/account/booking-details/pages/components/CancelBookingAction/steps/PartialCancellationSubmitResult'
import { VoucherCancellationSubmitResult } from '@/scopes/account/booking-details/pages/components/CancelBookingAction/steps/VoucherCancellationSubmitResult'

type CancelBookingSubmitStatus = 'success' | 'error'

interface PartialCancellationSubmitResultRouteProps {
  status: CancelBookingSubmitStatus
  step: Exclude<CancelBookingFlowStep, 'full-cancellation-confirmation' | 'voucher-cancellation-confirmation'>
}

interface VoucherCancellationSubmitResultRouteProps {
  status: CancelBookingSubmitStatus
  step: 'voucher-cancellation-confirmation'
}

interface FullCancellationSubmitResultRouteProps {
  status: CancelBookingSubmitStatus
  step: 'full-cancellation-confirmation'
  fullCancellationVariant: FullCancellationSheetVariant
}

type CancelBookingSubmitResultProps =
  | PartialCancellationSubmitResultRouteProps
  | VoucherCancellationSubmitResultRouteProps
  | FullCancellationSubmitResultRouteProps

export function CancelBookingSubmitResult({ status, ...props }: CancelBookingSubmitResultProps) {
  if (props.step === 'voucher-cancellation-confirmation')
    return <VoucherCancellationSubmitResult status={status} />

  if (props.step !== 'full-cancellation-confirmation')
    return <PartialCancellationSubmitResult status={status} />

  const { fullCancellationVariant } = props

  if (status === 'error')
    return <FullCancellationErrorResult variant={fullCancellationVariant} />

  return <FullCancellationSubmitResult variant={fullCancellationVariant} />
}
